import { render } from "./FollowUp.vue?vue&type=template&id=64aef7c4&scoped=true"
import script from "./FollowUp.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUp.vue?vue&type=script&setup=true&lang=js"

import "./FollowUp.vue?vue&type=style&index=0&id=64aef7c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64aef7c4"],['__file',"resources/js/modules/learning_module/components/question/FollowUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64aef7c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64aef7c4', __exports__)) {
    api.reload('64aef7c4', __exports__)
  }
  
  module.hot.accept("./FollowUp.vue?vue&type=template&id=64aef7c4&scoped=true", () => {
    api.rerender('64aef7c4', render)
  })

}


export default __exports__